var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("van-popup", {
    model: {
      value: _vm.isShowPop,
      callback: function callback($$v) {
        _vm.isShowPop = $$v;
      },
      expression: "isShowPop"
    }
  }, [_c("div", {
    staticClass: "pop-con"
  }, [_c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("div", {
    on: {
      click: _vm.closePop
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/close.png"),
      alt: ""
    }
  })]), _c("span", [_vm._v(_vm._s(_vm.$t("ChooseTopics")))])]), _c("div", {
    staticClass: "input-con"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    ref: "inputs",
    attrs: {
      maxlength: "20",
      type: "text",
      placeholder: _vm.$t("Search")
    },
    domProps: {
      value: _vm.value
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.value = $event.target.value;
      }, function ($event) {
        $event.stopPropagation();
        return _vm.input.apply(null, arguments);
      }]
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEmpty,
      expression: "!isEmpty"
    }],
    staticClass: "clear-icon",
    on: {
      click: _vm.clear
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/close.png"),
      alt: ""
    }
  })])]), !_vm.isInput ? _c("div", {
    staticClass: "menu-list"
  }, [_c("h4", [_vm._v(_vm._s(_vm.$t("HotTopic")))]), _vm._l(_vm.hotTopicList, function (item) {
    return _c("div", {
      key: item.content,
      staticClass: "menu-item",
      on: {
        click: function click($event) {
          return _vm.getTopic(item.topicId, item.content);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/ic_other_more_label.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.content))])]), _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(item.threadCount) + " " + _vm._s(_vm.$t("Posts")))])]);
  })], 2) : _vm._e(), _vm.isInput ? _c("div", {
    staticClass: "menu-list"
  }, [_vm._l(_vm.searchTopicList, function (item) {
    return _c("div", {
      key: item.content,
      staticClass: "menu-item",
      on: {
        click: function click($event) {
          return _vm.getTopic(item.topicId, item.content);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/ic_other_more_label.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.content))])]), _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(item.threadCount) + " " + _vm._s(_vm.$t("Posts")))])]);
  }), _vm.isGetResault ? _c("div", {
    staticClass: "menu-item",
    on: {
      click: function click($event) {
        return _vm.createTopic(_vm.value);
      }
    }
  }, [_c("div", {
    staticClass: "left"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_label.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.value))])]), _c("span", {
    staticClass: "create"
  }, [_vm._v(_vm._s(_vm.$t("CreateATopic")))])]) : _vm._e()], 2) : _vm._e()])])]), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    class: ["btn", {
      black: _vm.highLight
    }],
    on: {
      click: _vm.publish
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Post")) + " ")])]), _vm.pid === "1" && _vm.value1 === "4" ? _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.title,
      expression: "title"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Title"
    },
    domProps: {
      value: _vm.title
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.title = $event.target.value;
      }
    }
  })]) : _vm._e(), _c("van-field", {
    attrs: {
      rows: "8",
      autosize: "",
      type: "textarea",
      maxlength: "300",
      placeholder: _vm.$t("Pstswy"),
      "show-word-limit": ""
    },
    on: {
      input: _vm.fieleInput
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _c("div", {
    staticClass: "upload-con"
  }, [_c("div", {
    staticClass: "upload"
  }, [_vm.isAndorid ? [_vm.type === "1" ? _c("div", {
    staticClass: "van-uploader"
  }, [_c("div", {
    staticClass: "van-uploader__wrapper"
  }, [_vm._l(_vm.fileList, function (itmimg, index) {
    return _c("div", {
      key: index,
      staticClass: "van-uploader__preview"
    }, [_c("div", {
      staticClass: "van-image van-uploader__preview-image"
    }, [_c("van-image", {
      staticClass: "uploadImage",
      attrs: {
        src: itmimg.url,
        alt: ""
      }
    })], 1), _c("div", {
      staticClass: "van-uploader__preview-delete",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.handleDelImg(index);
        }
      }
    }, [_c("i", {
      staticClass: "van-icon van-icon-cross van-uploader__preview-delete-icon"
    })])]);
  }), _vm.fileList.length < 9 ? _c("div", {
    staticClass: "van-uploader__upload"
  }, [_c("div", {
    staticClass: "upload_andorid",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.openActionSheet.apply(null, arguments);
      }
    }
  }, [_c("i", {
    staticClass: "van-icon van-icon-photograph van-uploader__upload-icon"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm.type === "2" ? _c("div", {
    staticClass: "van-uploader"
  }, [_c("div", {
    staticClass: "van-uploader__wrapper"
  }, [_vm._l(_vm.fileList, function (itmimg, index) {
    return _c("div", {
      key: index,
      staticClass: "van-uploader__preview"
    }, [_c("div", {
      staticClass: "van-image van-uploader__preview-image"
    }, [_c("video", {
      staticClass: "uploadImage",
      attrs: {
        src: itmimg.url,
        alt: ""
      }
    })]), _c("div", {
      staticClass: "van-uploader__preview-delete",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.handleDelImg(index);
        }
      }
    }, [_c("i", {
      staticClass: "van-icon van-icon-cross van-uploader__preview-delete-icon"
    })])]);
  }), _vm.fileList.length == 0 ? _c("div", {
    staticClass: "van-uploader__upload"
  }, [_c("div", {
    staticClass: "upload_andorid",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.beforeReadFile(2);
      }
    }
  }, [_c("i", {
    staticClass: "van-icon van-icon-photograph van-uploader__upload-icon"
  })])]) : _vm._e()], 2)]) : _vm._e()] : [_vm.type === "1" ? _c("van-uploader", {
    attrs: {
      "max-size": 10 * 1024 * 1024,
      accept: _vm.limited ? "image/*" : "",
      "after-read": _vm.afterRead,
      multiple: "",
      "max-count": 9,
      "before-read": _vm.beforeRead
    },
    on: {
      oversize: _vm.onOversizeP,
      delete: _vm.del
    },
    model: {
      value: _vm.fileList,
      callback: function callback($$v) {
        _vm.fileList = $$v;
      },
      expression: "fileList"
    }
  }) : _vm._e(), _vm.type === "2" ? _c("van-uploader", {
    attrs: {
      "max-size": 250 * 1024 * 1024,
      accept: _vm.limited ? "video/*" : "",
      videoPoster: "./video.png",
      multiple: false,
      "after-read": _vm.afterRead,
      "max-count": 1
    },
    on: {
      oversize: _vm.onOversize,
      delete: _vm.del
    },
    scopedSlots: _vm._u([{
      key: "preview-cover",
      fn: function fn(_ref) {
        var file = _ref.file;
        return [_c("img", {
          staticClass: "uploadImg",
          attrs: {
            src: require("../../assets/images/pic_post_video.png"),
            alt: ""
          }
        })];
      }
    }], null, false, 699588051),
    model: {
      value: _vm.fileList,
      callback: function callback($$v) {
        _vm.fileList = $$v;
      },
      expression: "fileList"
    }
  }) : _vm._e()]], 2)]), _vm.type == "2" ? _c("div", {
    staticClass: "tips"
  }, [_vm._v(" " + _vm._s(_vm.$t("OSUOOV")) + " ")]) : _vm._e(), _c("div", {
    staticClass: "radio"
  }, [_c("van-radio-group", {
    attrs: {
      direction: "horizontal"
    },
    on: {
      change: _vm.fileChange
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, [_c("van-radio", {
    attrs: {
      name: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("image")))]), _c("van-radio", {
    attrs: {
      name: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("Video")))])], 1)], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pid === "1",
      expression: "pid === '1'"
    }],
    staticClass: "radio"
  }, [_c("van-radio-group", {
    attrs: {
      direction: "horizontal"
    },
    on: {
      change: _vm.cateoryChange
    },
    model: {
      value: _vm.value1,
      callback: function callback($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  }, [_c("van-radio", {
    attrs: {
      name: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("Community")))]), _c("van-radio", {
    attrs: {
      name: "4"
    }
  }, [_vm._v("News")])], 1)], 1), _vm.value1 === "1" ? _c("div", {
    staticClass: "search-history"
  }, [_c("div", {
    staticClass: "title",
    on: {
      click: _vm.topicSearch
    }
  }, [_c("div", {
    staticClass: "addTopic"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_post_add_topic_normal.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("AddTopic")))])]), _c("img", {
    attrs: {
      src: require("../../assets/images/ic_common_next.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "search-history-list"
  }, _vm._l(_vm.selectTopicList, function (itm) {
    return _c("van-tag", {
      key: itm.topicId,
      staticClass: "item",
      attrs: {
        closeable: "",
        size: "medium",
        type: "primary"
      },
      on: {
        close: function close($event) {
          return _vm.close(itm.topicId);
        }
      }
    }, [_vm._v(" #" + _vm._s(itm.topic) + " ")]);
  }), 1)]) : _vm._e(), _c("van-action-sheet", {
    staticClass: "action-wrap",
    attrs: {
      "cancel-text": _vm.$t("Cancel"),
      actions: this.type == 2 ? _vm.actionsVideos : _vm.actionsPicture
    },
    on: {
      select: _vm.onSelectPicture
    },
    model: {
      value: _vm.showSheet,
      callback: function callback($$v) {
        _vm.showSheet = $$v;
      },
      expression: "showSheet"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };